import { render, staticRenderFns } from "./CharacterStory.vue?vue&type=template&id=3fb8e32c&scoped=true"
import script from "./CharacterStory.vue?vue&type=script&lang=js"
export * from "./CharacterStory.vue?vue&type=script&lang=js"
import style0 from "./CharacterStory.vue?vue&type=style&index=0&id=3fb8e32c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb8e32c",
  null
  
)

export default component.exports